import React, { Component } from 'react'

import { Page, PageList, PaginatorContainer } from './styles'
import ChevronLeft from '../../../elements/Icons/ChevronLeft'
import ChevronRight from '../../../elements/Icons/ChevronRight'

const getNumberOfPages = (total, quantidade) => {
  return Math.ceil(total / quantidade)
}

export class IdentifierPaginator extends Component {
  render() {
    const { total = 0, quantidade = 24, changePage, paginaAtual = 1 } = this.props
    const numberOfPages = getNumberOfPages(total, quantidade)

    const delta = 2
    const left = paginaAtual - delta
    const right = paginaAtual + delta + 1
    let range = []
    let rangeWithDots = []
    let l

    for (let i = 1; i <= numberOfPages; i++) {
      if (i === 1 || i === numberOfPages || (i >= left && i < right)) {
        range.push(i)
      }
    }

    for (let i of range) {
      if (l) {
        if (i - l === 2) {
          rangeWithDots.push(l + 1)
        } else if (i - l !== 1) {
          rangeWithDots.push('...')
        }
      }
      rangeWithDots.push(i)
      l = i
    }

    return (
      <PaginatorContainer>
        <div>
          <ChevronLeft disabled={paginaAtual === 1} onClick={() => changePage(paginaAtual - 1)} />
          <PageList>
            {rangeWithDots.map((p, i) => {
              if (p === '...') {
                return (
                  <span style={{ padding: '4px' }} key={`page-${i}`}>
                    {p}
                  </span>
                )
              }

              return (
                <Page
                  isCurrentPage={p === paginaAtual}
                  onClick={() => changePage(p)}
                  key={`page-${i}`}
                >
                  {p}
                </Page>
              )
            })}
          </PageList>
          <ChevronRight
            disabled={numberOfPages === paginaAtual}
            onClick={() => changePage(paginaAtual + 1)}
          />
        </div>
      </PaginatorContainer>
    )
  }
}

export default IdentifierPaginator



// WEBPACK FOOTER //
// ./src/app/pages/DashboardStatement/FilterByIdentifier/IdentifierPaginator.js